import React from 'react';
import CollectionPage from '../shared/CollectionPage';

/**
 * LEGO Wishlist Dashboard component
 * Uses the generic CollectionPage with LEGO-specific configuration for wishlist
 */
const LegoWishlistDashboard = () => {
  // LEGO-specific filter options (by theme ID)
  const legoFilterOptions = [
    { value: '1', label: 'Technic' },
    { value: '22', label: 'Creator' },
    { value: '158', label: 'Star Wars' },
    { value: '246', label: 'Harry Potter' },
    { value: '593', label: 'Ideas' },
    { value: '576', label: 'Ninjago' },
    { value: '621', label: 'Marvel' },
    { value: '695', label: 'DC Comics' }
  ];

  // LEGO-specific render props
  const legoRenderProps = {
    getImageUrl: (item) => item.set_img_url || item.imageUrl,
    getItemName: (item) => item.name,
    getItemSubtitle: (item) => {
      const setNum = item.setNum || item.set_num;
      return `Set #: ${setNum ? setNum.split('-')[0] : 'N/A'} • Year: ${item.year || 'N/A'}`;
    },
    getItemDetails: (item) => `Priority: ${item.priority || 'Medium'}`,
    isWishlist: true
  };

  // LEGO-specific filter function (by theme ID)
  const getLegoFilterValue = (item) => item.themeId?.toString() || item.theme_id?.toString() || '';

  // LEGO-specific edit fields
  const legoEditFields = [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      gridProps: { xs: 12 }
    },
    {
      name: 'setNum',
      label: 'Set Number',
      type: 'text',
      required: true,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'year',
      label: 'Year',
      type: 'number',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'themeId',
      label: 'Theme ID',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'priority',
      label: 'Priority',
      type: 'select',
      options: ['Low', 'Medium', 'High'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'set_img_url',
      label: 'Image URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'rating',
      label: 'Rating',
      type: 'rating',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'notes',
      label: 'Notes',
      type: 'text',
      multiline: true,
      rows: 4,
      required: false,
      gridProps: { xs: 12 }
    }
  ];

  return (
    <CollectionPage
      collectionType="lego-wishlist"
      title="LEGO Wishlist"
      isWishlist={true}
      itemType="lego"
      renderProps={legoRenderProps}
      filterOptions={legoFilterOptions}
      getFilterValue={getLegoFilterValue}
      editFields={legoEditFields}
    />
  );
};

export default LegoWishlistDashboard;
